import { useQuery } from '@hooks/reactQuery';

import { organisationBranding } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getBrandingSetups } from '@api/managePlatformBranding';

import { extractQueryParams } from '@utils/common';

import { IBrandingSetup } from '@interfaces/platform/branding';
import { IBrandingSetupsDTO } from '@interfaces/platform/dto/brandingDTO';

import { defaultBrandingSetupName, refetchOptions } from '@constants/common';
import { BRANDING_SETUPS } from '@constants/queryKeys';

interface IUseQueryBrandingSetups {
	isLoadingBrandingSetups: boolean;
	countOfRecords: number;
	brandingSetups: Array<IBrandingSetup>;
}

export const useQueryBrandingSetups = (): IUseQueryBrandingSetups => {
	const {
		page,
		pageSize,
		searchValue,
		sortFieldName,
		sortDirection,
	} = useAppSelector(organisationBranding);

	const {
		data: brandingSetups,
		isLoading: isLoadingBrandingSetups,
		isFetching: isFetchingBrandingSetups,
	} = useQuery<IBrandingSetupsDTO>({
			queryKey: [
				BRANDING_SETUPS,
				{
					page,
					pageSize,
					searchValue,
					sortFieldName,
					sortDirection,
				},
			],
			queryFn: extractQueryParams(getBrandingSetups),
			select: (brandingSetups: IBrandingSetupsDTO) => {
				return {
					...brandingSetups,
					items: brandingSetups?.items?.map(item => {
						return {
							...item,
							isSelectRowDisabled: item?.name === defaultBrandingSetupName,
						};
					}),
				};
			},
			...refetchOptions,
		},
	);

	return {
		isLoadingBrandingSetups: isLoadingBrandingSetups || isFetchingBrandingSetups,
		brandingSetups: brandingSetups?.items || [],
		countOfRecords: brandingSetups?.count || 0,
	};
};
